export default __webpack_public_path__ + "static/media/delete.8de089b5.svg";